module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-upload', {
    attrs: {
      "action": _vm.uploadUrl,
      "multiple": "",
      "list-type": _vm.listType,
      "drag": _vm.typeDrag && !_vm.disabled,
      "on-success": _vm.successCb,
      "on-preview": _vm.preview,
      "on-remove": _vm.removeCb,
      "on-progress": _vm.uploadProgress,
      "on-error": _vm.uploadError,
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.fileList
    }
  }, [((_vm.typeFileList || _vm.typeImageList) && !_vm.disabled) ? _c('div', [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])]) : _vm._e(), _vm._v(" "), (_vm.typePhotoWall && !_vm.disabled) ? _c('div', [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _vm._e(), _vm._v(" "), (_vm.typeDrag && !_vm.disabled) ? _c('div', [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])])]) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('div', {
    staticClass: "el-upload__tip",
    slot: "tip"
  }, [_vm._v("只能上传" + _vm._s(_vm.getFileType(_vm.config.file_type)) + "文件，且不超过" + _vm._s(_vm.config.file_max) + _vm._s(_vm.getFileUnit(_vm.config.file_unit)))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-654278ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/business/inputs/honrayUpload.vue
// module id = 1894
// module chunks = 2